import React,{useState,useEffect} from 'react'
import { Accordion, Spinner } from 'flowbite-react'
import axios from 'axios'
export default function OfflineClasses({course_id}) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([])
    const [lan, setLan] = useState('bangla')
    const baseURL = "https://mukti-backend-bd.onrender.com"
    const getData = async () => {
        try {
            const res = await axios.get(`${baseURL}/os/${course_id}`)
            console.log(res.data)
            setData(res.data)
            setLoading(false)
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        if (localStorage.getItem('language') === 'english') {
            setLan('english')
        } else {
            setLan('bangla')
        }
        getData()
    }, [])
  return loading? <Spinner/> :(
    <div className='w-full flex flex-wrap items-center justify-center'>
         {data.map(a => (<img class=" rounded-lg sm:rounded-none sm:rounded-l-lg" src={a.link}/>))}
    </div>
  )
}
